import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import { auth } from './../firebase/firebaseConfig';
import { useNavigate, Link } from 'react-router-dom';
import Alerta from './../elementos/Alerta';
import { createUserWithEmailAndPassword } from "firebase/auth";
import { ReactComponent as SvgRegistro } from './../imagenes/login.svg';

const ContenedorRegistro = styled.div`
	width: 100%;
	min-height: 100vh;

	display: flex;
	align-items: center;
	justify-content: center;

	padding: 24px;

	box-sizing: border-box;
`;

const Card = styled.div`
	background: rgba(255,255,255,0.96);

	padding: 36px 32px;

	border-radius: 32px;

	width: 100%;
	max-width: 460px;

	box-shadow:
		0 20px 40px rgba(0,0,0,0.12),
		0 4px 10px rgba(0,0,0,0.05);

	display: flex;
	flex-direction: column;
	align-items: center;

	box-sizing: border-box;
`;

const Svg = styled(SvgRegistro)`
	width: 160px;
	height: auto;

	margin-bottom: 20px;
`;

const Titulo = styled.h1`
	font-size: 2rem;
	font-weight: 700;

	color: #111;

	margin-bottom: 28px;

	text-align: center;
`;

const Formulario = styled.form`
	width: 100%;
`;

const Input = styled.input`
	width: 100%;

	height: 58px;

	border: 1px solid #E5E7EB;

	border-radius: 16px;

	padding: 0 18px;

	font-size: 16px;

	margin-bottom: 16px;

	box-sizing: border-box;

	outline: none;

	transition: .2s ease all;

	&:focus {
		border: 1px solid #5B69E2;
		box-shadow: 0 0 0 4px rgba(91,105,226,0.12);
	}
`;

const Boton = styled.button`
	width: 100%;

	height: 58px;

	border: none;

	border-radius: 16px;

	background: #5B69E2;

	color: #fff;

	font-size: 16px;
	font-weight: 600;

	cursor: pointer;

	transition: .2s ease all;

	margin-top: 8px;

	&:hover {
		transform: translateY(-1px);
	}
`;

const TextoLogin = styled.p`
	margin-top: 20px;

	font-size: 14px;

	color: #555;

	text-align: center;
`;

const RegistroUsuarios = () => {
	const navigate = useNavigate();

	const [correo, establecerCorreo] = useState('');
	const [password, establecerPassword] = useState('');
	const [password2, establecerPassword2] = useState('');

	const [estadoAlerta, cambiarEstadoAlerta] = useState(false);
	const [alerta, cambiarAlerta] = useState({});

	const handleChange = (e) => {
		switch(e.target.name){
			case 'email':
				establecerCorreo(e.target.value);
				break;

			case 'password':
				establecerPassword(e.target.value);
				break;

			case 'password2':
				establecerPassword2(e.target.value);
				break;

			default:
				break;
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		cambiarEstadoAlerta(false);
		cambiarAlerta({});

		const expresionRegular =
			/[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+/;

		if(!expresionRegular.test(correo)){
			cambiarEstadoAlerta(true);

			cambiarAlerta({
				tipo: 'error',
				mensaje: 'Por favor ingresa un correo válido'
			});

			return;
		}

		if(correo === '' || password === '' || password2 === ''){
			cambiarEstadoAlerta(true);

			cambiarAlerta({
				tipo: 'error',
				mensaje: 'Por favor rellena todos los datos'
			});

			return;
		}

		if(password !== password2){
			cambiarEstadoAlerta(true);

			cambiarAlerta({
				tipo: 'error',
				mensaje: 'Las contraseñas no coinciden'
			});

			return;
		}

		try {
			await createUserWithEmailAndPassword(auth, correo, password);

			navigate('/');

		} catch(error){

			cambiarEstadoAlerta(true);

			let mensaje;

			switch(error.code){

				case 'auth/invalid-password':
					mensaje = 'La contraseña debe tener mínimo 6 caracteres.';
					break;

				case 'auth/email-already-in-use':
					mensaje = 'Ese correo ya está registrado.';
					break;

				case 'auth/invalid-email':
					mensaje = 'El correo electrónico no es válido.';
					break;

				default:
					mensaje = 'Hubo un error al crear la cuenta.';
					break;
			}

			cambiarAlerta({
				tipo: 'error',
				mensaje
			});
		}
	};

	return (
		<>
			<Helmet>
				<title>Crear Cuenta</title>
			</Helmet>

			<ContenedorRegistro>

				<Card>

					<Svg />

					<Titulo>
						✨ Crear cuenta
					</Titulo>

					<Formulario onSubmit={handleSubmit}>

						<Input
							type="email"
							name="email"
							placeholder="Correo electrónico"
							value={correo}
							onChange={handleChange}
						/>

						<Input
							type="password"
							name="password"
							placeholder="Contraseña"
							value={password}
							onChange={handleChange}
						/>

						<Input
							type="password"
							name="password2"
							placeholder="Repetir contraseña"
							value={password2}
							onChange={handleChange}
						/>

						<Boton type="submit">
							Crear cuenta
						</Boton>

					</Formulario>

					<TextoLogin>
						¿Ya tienes cuenta?{' '}
						<Link
							to="/iniciar-sesion"
							style={{
								color: '#5B69E2',
								fontWeight: '600',
								textDecoration: 'none'
							}}
						>
							Inicia sesión
						</Link>
					</TextoLogin>

				</Card>

			</ContenedorRegistro>

			<Alerta
				tipo={alerta.tipo}
				mensaje={alerta.mensaje}
				estadoAlerta={estadoAlerta}
				cambiarEstadoAlerta={cambiarEstadoAlerta}
			/>
		</>
	);
};

export default RegistroUsuarios;